import { render } from "./Usage.vue?vue&type=template&id=9ce23fe2"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"
script.render = render

export default script